const topicItems = [
  { label: '最新电影', hot: true, count: '2.3万' },
  { label: '熬夜追剧', hot: true, count: '1.8万' },
  { label: '高清影视', hot: true, count: '1.6万' },
  { label: '免费影院', hot: false, count: '1.4万' },
  { label: '不卡顿', hot: false, count: '9.8千' },
  { label: '秒播', hot: true, count: '8.7千' },
  { label: '电影大全', hot: false, count: '7.5千' },
  { label: '经典电影', hot: false, count: '6.3千' },
  { label: '在线观看', hot: true, count: '5.9千' },
  { label: '深夜剧场', hot: false, count: '4.8千' },
  { label: '热门剧集', hot: true, count: '4.2千' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          当前最受关注的影视话题标签，看看大家都在追什么
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((item, idx) => (
            <span
              key={idx}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 hover:-translate-y-0.5 ${
                item.hot
                  ? 'bg-accent-100/70 border-accent-300/60 text-accent-700 hover:bg-accent-200/70'
                  : 'bg-background-100/70 border-background-200/60 text-foreground-600 hover:bg-background-200/70'
              }`}
            >
              {item.hot && <i className="ri-fire-line text-accent-500 text-xs"></i>}
              {item.label}
              <span className={`text-xs ${item.hot ? 'text-accent-500' : 'text-foreground-400'}`}>
                {item.count}
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}